import {ReactNode} from 'react'
import cn from 'clsx'
import {Link, To} from 'react-router-dom'

import './Block.scss'

interface BlockProps {
  children: ReactNode
  as?: any
  className?: string
  relative?: boolean
  type?:
    | 'default'
    | 'grey'
    | 'black'
    | 'transparent'
    | 'turquoize'
    | 'green'
    | 'red'
    | 'white'
    | 'stone3'
    | 'card-bg'
  to?: To
  onClick?: () => void
}

export default function Block({
  children,
  as: Component = 'div',
  className,
  relative,
  type = 'default',
  to,
  onClick,
}: BlockProps) {
  const classes = cn(
    className,
    `Block Block_type_${type}`,
    to && 'Block_link',
    onClick && 'Block_button',
    relative && 'Block_relative'
  )

  if (to) {
    return (
      <Component>
        <Link className={classes} to={to} onClick={onClick}>
          {children}
        </Link>
      </Component>
    )
  }

  if (onClick) {
    return (
      <Component>
        <button className={classes} onClick={onClick}>
          {children}
        </button>
      </Component>
    )
  }

  return <Component className={classes}>{children}</Component>
}
